import React from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import * as pdfjsLib from "pdfjs-dist";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import ErrorContainer from "./ErrorContainer";
import LoadingContainer from "./LoadingContainer";
import PageContainer from "./PageContainer";
import { DocumentViewerProps } from "../types/types";

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const options = {
  cMapUrl: "cmaps/",
  cMapPacked: true,
};

const DocumentViewer: React.FC<DocumentViewerProps> = ({ url, numPages, onDocumentLoadSuccess }) => {
  if (!url) {
    return <ErrorContainer>Documento não disponível</ErrorContainer>;
  }

  const pdfSource = url.startsWith("data:") || url.startsWith("https") ? url : `data:application/pdf;base64,${url}`;

  const handleLoadError = (error: Error) => {
    console.error("PDF load error:", error);
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Document
        file={pdfSource}
        onLoadSuccess={onDocumentLoadSuccess}        
        onLoadError={((error: Error) => {
          console.error("PDF load error:", error);
        }) as unknown as () => void}
        options={options}
        loading={<LoadingContainer>Carregando documento...</LoadingContainer>}
        error={<ErrorContainer>Erro ao carregar o documento. Tente novamente.</ErrorContainer>}
      >
        {Array.from(new Array(numPages), (_, index) => (
          <PageContainer key={`page_${index + 1}`} style={{ display: "flex", justifyContent: "center" }}>
            <Page pageNumber={index + 1} className="pdf-page" renderTextLayer={false} renderAnnotationLayer={false} />
          </PageContainer>
        ))}
      </Document>
    </div>
  );
};

export default DocumentViewer;
